import {
  Accordion,
  Bubble,
  Icon,
  Markdown,
} from '@frontendmentorio/design-system-v2';

function Heading({ count, isOpen, ...props }) {
  return (
    <h2
      className="cursor-pointer flex justify-between font-secondary items-center p-4 text-xl"
      {...props}
    >
      <span className="flex gap-2 items-center">
        Strengths
        <Bubble className="bg-green-600 w-[1.8rem]" size="sm">
          {count}
        </Bubble>
      </span>
      <Icon
        className="text-neutral-500 text-sm"
        name={isOpen ? 'chevron-down' : 'chevron-right'}
        style="solid"
      />
    </h2>
  );
}

export default function Strengths({ report }) {
  if (!report?.strengths?.length) return null;

  return (
    <Accordion heading={<Heading count={report?.strengths?.length} />}>
      <ul className="flex flex-col gap-5 items-start p-4">
        {report?.strengths?.map((strength, index) => (
          <li
            className="bg-neutral-50 border border-neutral-200 flex flex-col gap-3 items-start p-3 rounded-lg w-full"
            key={index}
          >
            <h3 className="bg-green-600 font-secondary font-semibold leading-none px-2 py-1 rounded text-white text-sm">
              {strength.category}
            </h3>
            <Markdown>{strength.description}</Markdown>
          </li>
        ))}
      </ul>
    </Accordion>
  );
}
